import { useState } from 'react'
import { RefreshCw, AlertCircle } from 'lucide-react'
import SummaryCards from '../components/revenue/SummaryCards'
import DailyChart from '../components/revenue/DailyChart'
import { useRevenueSummary, useDailyRevenue } from '../hooks/useRevenue'
import { getDateRange } from '../lib/utils'

export default function Dashboard() {
  const [dateRange, setDateRange] = useState(30)
  const { startDate, endDate } = getDateRange(dateRange)

  const summary = useRevenueSummary()
  const dailyRevenue = useDailyRevenue({
    start_date: startDate,
    end_date: endDate,
  })

  const loading = summary.loading || dailyRevenue.loading
  const error = summary.error || dailyRevenue.error

  const handleRefresh = async () => {
    await Promise.all([summary.refetch(), dailyRevenue.refetch()])
  }

  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4">
        <div>
          <h1 className="text-xl sm:text-2xl font-bold text-white">Revenue Dashboard</h1>
          <p className="text-sm sm:text-base text-slate-400 mt-1">
            Track platform revenue from campaign fees and survey commissions
          </p>
        </div>
        <button
          onClick={handleRefresh}
          disabled={loading}
          className="btn-secondary flex items-center justify-center gap-2 w-full sm:w-auto"
        >
          <RefreshCw size={16} className={loading ? 'animate-spin' : ''} />
          Refresh
        </button>
      </div>

      {/* Error Alert */}
      {error && (
        <div className="flex items-center gap-3 p-4 bg-red-500/10 border border-red-500/50 rounded-lg">
          <AlertCircle size={20} className="text-red-400" />
          <div>
            <p className="font-medium text-red-400">Error loading data</p>
            <p className="text-sm text-red-400/80">{error}</p>
          </div>
          <button
            onClick={handleRefresh}
            className="ml-auto text-sm text-red-400 hover:text-red-300 underline"
          >
            Try again
          </button>
        </div>
      )}

      {/* Summary Cards */}
      <SummaryCards data={summary.data} loading={summary.loading} />

      {/* Daily Revenue Chart */}
      <DailyChart
        data={dailyRevenue.data}
        loading={dailyRevenue.loading}
        dateRange={dateRange}
        onDateRangeChange={setDateRange}
      />
    </div>
  )
}
